// /src/RootErrorBoundary.jsx

import React from "react";

export default class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[React ErrorBoundary] Caught:", error);
    console.error(info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="root-error-boundary">
          <h2>React crashed in:</h2>
          <pre>{this.state.error.message}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}
